import { ApiTypes } from '../../types';
export function isUserSiteAdmin(user) {
    return user && user.role === 'Admin';
}
export function isUserLoggedIn(user) {
    return user && user.loggedIn;
}
export function canCreateGroup(user, createGroupPolicy) {
    var isLoggedIn = isUserLoggedIn(user);
    if (!isLoggedIn) {
        return false;
    }
    var isAdmin = isUserSiteAdmin(user);
    if (isAdmin) {
        return true;
    }
    var isOnlyAdminCanCreateGroups = createGroupPolicy === ApiTypes.v1.CreateGroupsPolicy.ONLY_ME;
    return !isOnlyAdminCanCreateGroups;
}
export function canResolvePendingGroups(user) {
    return isUserLoggedIn(user) && isUserSiteAdmin(user);
}
//# sourceMappingURL=permissions.js.map